export default __webpack_public_path__ + "static/media/YuliaPic.1a2bdfdd.jpg";